const loadingEl = document.querySelector(".loader");

document.addEventListener('DOMContentLoaded', () => {
  loadingEl.style.display = 'none'
})